export const defaultLicenseInfoState = {
	SumanLicenseInfo: {}, // Thông tin license bên suman
	licenseInfo: {}, // Thông tin license lưu trên app
	PaymentStatus: [],
	OrderList: [],
	TotalOrderList: 0
};

export default {
	...defaultLicenseInfoState
};
